import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Subject, mergeMap, Subscription } from 'rxjs';
import { LoggerService } from '@lib.core/logger/logger.service';
import { IsHeadlessStorageService } from '@public/src/app/store/store-access/is-headless-storage.service';

@Injectable({
  providedIn: 'root'
})
export class IsHeadlessQParamInteractor {
  private readonly isHeadlessParam = 'isHeadless';
  private readonly subscriptions: Subscription[] = [];
  private logger: LoggerService;
  private readonly qParamReaderTrigger$$ = new Subject<void>();
  private readonly qParamReaderTrigger$ = this.qParamReaderTrigger$$.asObservable();

  constructor(
    private activatedRoute: ActivatedRoute,
    private isHeadlessService: IsHeadlessStorageService
  ) {
    this.logger = LoggerService.getLoggerService();
    this.subscribeToQParamReader();
  }

  readIsHeadlessFromQParam() {
    this.qParamReaderTrigger$$.next();
  }

  destroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private subscribeToQParamReader() {
    this.subscriptions.push(
      this.qParamReaderTrigger$.pipe(
        mergeMap(() => this.activatedRoute.queryParams),
        map(qp => qp[this.isHeadlessParam] === 'true')
      )
      .subscribe({
        next:  (isHeadless: boolean) => {
          this.isHeadlessService.setIsHeadless(isHeadless);
        },
        error: (error) => this.logger.error(error),
      })
    );
  }
}
